import { useState, useRef } from "react";
import { Play, X } from "lucide-react";
import { extractYouTubeVideoId } from "../../utils/api";

export { extractYouTubeVideoId };

export const VideoPlayer = ({ source, type, title, poster, autoPlay = false }) => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  if (type === 'youtube') {
    const videoId = source.includes('youtube.com') 
      ? source.split('v=')[1]?.split('&')[0]
      : source.includes('youtu.be') ? source.split('/').pop() : source;
    return (
      <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden">
        <iframe src={`https://www.youtube.com/embed/${videoId}?autoplay=${autoPlay ? 1 : 0}&mute=1&rel=0&modestbranding=1`} title={title} className="absolute inset-0 w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      </div>
    );
  }

  if (type === 'direct' || type === 'mp4' || type === 'webm') {
    return (
      <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden group">
        <video ref={videoRef} src={source} poster={poster} className="w-full h-full object-contain" controls muted={isMuted} autoPlay={autoPlay} />
        <div className="absolute top-4 left-4 bg-black/70 px-3 py-1 rounded text-sm">{title}</div>
      </div>
    );
  }

  if (type === 'embed') {
    return (
      <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden">
        <iframe src={source} title={title} className="absolute inset-0 w-full h-full" allowFullScreen />
      </div>
    );
  }

  return (
    <div className="relative w-full aspect-video bg-gray-900 rounded-lg overflow-hidden flex items-center justify-center">
      <div className="text-center">
        <Play size={64} className="text-red-600 mx-auto mb-4" />
        <h3 className="text-white text-lg font-bold mb-2">{title}</h3>
        <p className="text-gray-400 text-sm">Stream type: {type}</p>
        {source && (
          <button onClick={() => window.open(source, '_blank')} className="mt-4 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded">Open Stream</button>
        )}
      </div>
    </div>
  );
};

export const YouTubePlayer = ({ videoId, autoplay = false, title = "", onClose }) => {
  if (!videoId) return null;
  const embedUrl = `https://www.youtube.com/embed/${videoId}?${autoplay ? 'autoplay=1&' : ''}rel=0&modestbranding=1`;
  return (
    <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden" data-testid="youtube-player">
      {onClose && (
        <button onClick={onClose} className="absolute top-2 right-2 z-10 bg-black/70 hover:bg-red-600 p-2 rounded-full transition-colors">
          <X size={20} className="text-white" />
        </button>
      )}
      <iframe src={embedUrl} title={title || "YouTube Video"} className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
    </div>
  );
};
